import Crossword from "./Crossword";

export default interface Cell {
    row: number;
    col: number;
}

export function cellToIndex(cw: Crossword, cell: Cell): number {
    return cw.size.cols * cell.row + cell.col;
}